import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowRight, Building2, House, Sparkles, Briefcase, Truck, ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const services = [{
  title: "House Cleaning",
  description: "Thoughtful maintenance for your most personal spaces.",
  icon: House,
  href: "#"
}, {
  title: "Deep Cleaning",
  description: "A thorough restoration of every surface and corner.",
  icon: Sparkles,
  href: "#"
}, {
  title: "Move-In / Out",
  description: "Seamless transitions for your new beginning.",
  icon: Truck,
  href: "#"
}, {
  title: "Organizing",
  description: "Curated order to bring calm to your daily life.",
  icon: ShieldCheck,
  href: "#"
}, {
  title: "Renovation",
  description: "Post-construction care to unveil your vision.",
  icon: Building2,
  href: "#"
}, {
  title: "Commercial",
  description: "Professional standards for your business environment.",
  icon: Briefcase,
  href: "#"
}];
export default function ExpertCleaningSolutions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="19983" id="the-care-we-provide" ref={ref} className="bg-background py-20 lg:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className={cn("mb-12 text-center transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <h2 className="text-4xl font-bold tracking-tight text-primary sm:text-5xl font-default mb-4">
            The Care We Provide
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-foreground/60 font-default">
            Meticulous cleaning services designed for the modern home and professional space.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 lg:gap-12">
          {services.map((service, index) => <div key={index} data-index={index} className={cn("transition-all duration-700 ease-out delay-[var(--delay)]", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")} style={{
          "--delay": `${index * 100}ms`
        } as React.CSSProperties}>
              <Card className="group relative h-full overflow-hidden border-none bg-white shadow-none transition-all duration-500 hover:shadow-md">
                <CardContent className="flex h-full flex-col p-8 items-center text-center">
                  <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-transparent text-primary transition-transform duration-500 group-hover:scale-110">
                    <service.icon className="h-8 w-8" strokeWidth={1} />
                  </div>
                  
                  <h3 className="mb-3 font-default text-[18px] font-bold text-foreground">
                    {service.title}
                  </h3>
                  
                  <p className="mb-6 flex-grow text-foreground/50 leading-relaxed text-sm font-default">
                    {service.description}
                  </p>
                  
                  <div className="mt-auto opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                    <Link to={service.href} className="group/link inline-flex items-center text-xs font-semibold tracking-wider uppercase text-primary transition-colors hover:text-primary/80">
                      Learn More
                      <ArrowRight className="ml-2 h-3 w-3 transition-transform duration-300 group-hover/link:translate-x-1" />
                    </Link>
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}